const get = require('lodash/get')
const { update } = require('./save')
const { listUsersByRoutes, get: getUser } = require('../read')

async function assignRoute (state, {driver, routeId, defaultRole}) {
  // Validate routeId is provided and not null
  if (!routeId) {
    throw new Error(`routeId is required but was: ${routeId}`)
  }

  // Convert routeId to CouchDB format if needed (route:uuid or route:name)
  // Frontend may pass Postgres UUID (62dace3a-eeb3-4db3-8e3f-44c4d2a7a93c)
  // but driver routes array needs CouchDB format (route:62dace3a-eeb3-4db3-8e3f-44c4d2a7a93c)
  let routeIdToAssign = String(routeId).trim()
  if (!routeIdToAssign.startsWith('route:')) {
    // If it's a UUID or doesn't start with 'route:', prepend 'route:'
    routeIdToAssign = `route:${routeIdToAssign}`
  }

  const driversWithTheRoute = await listUsersByRoutes(state, {routes: [routeIdToAssign]})
  // We need this step to make sure we have the latest driver document
  // Extract driver name from driver.name or driver._id (format: org.couchdb.user:name)
  let driverName = driver.name
  if (!driverName && driver._id) {
    // Extract name from _id format: org.couchdb.user:name
    const match = driver._id.match(/^org\.couchdb\.user:(.+)$/)
    if (match) {
      driverName = match[1]
    } else {
      // If _id doesn't match expected format, use it as-is (might already be just the name)
      driverName = driver._id
    }
  }
  if (!driverName) {
    throw new Error('Driver name is required. Driver object must have either "name" or "_id" property.')
  }
  const driverToAssign = await getUser(state, driverName)

  const previousDriver = get(driversWithTheRoute, '0')

  await Promise.all([
    update(
      state,
      {
        ...driverToAssign,
        routes: [routeIdToAssign]
      },
      { defaultRole }
    ),
    previousDriver
      ? update(
        state,
        {
          ...previousDriver,
          routes: []
        },
        { defaultRole }
      )
      : Promise.resolve()
  ])
}
exports.assignRoute = assignRoute
